import React from 'react'
import { Box, Tooltip, tooltipClasses } from '@mui/material'
import { Link as Lnk } from 'react-router-dom'
import { styled } from '@mui/material/styles'

export const OuterWrapper = styled(Box)(`
  position:relative;
  width:56px;
  background-color: #E7E7E6;
  display:flex;
  height: 100vh;
  z-index: 15;
`)

export const SidebarContainer = styled(Box)(`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-item:center;
  width:100%;
  gap:12px;
`)

export const TopSection = styled(Box)(`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
`)

export const MiddleSection = styled(Box)(`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100vh;
  gap: 8px;
`)

export const BottomSection = styled(Box)(`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding: 20px 0px;
`)

export const LogoImage = styled('img')(`
  height: 40px;
  display: block;
`)

export const IconWrapperLink = styled(Lnk)(`
  padding: 6px;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: background-color 0.2s, color 0.2s;
  color: #1C1B1F;

  &:hover, &.active {
    background-color: black;
    color:white;

    & svg path { fill: white; }
  }

  svg {
    display: block;
  }
`)

export const IconWrapperButton = styled('button')(`
  all: unset;
  padding: 6px;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: background-color 0.2s, color 0.2s;
  color: #1C1B1F;

  &:hover, &.active {
    background-color: black;
    color:white;
    & svg path { fill: white; }
  }

  svg {
    display: block;
  }
`)

export const ProfileWrap = styled(Box)(`
  border: 1px solid #636363; 
  height:36px;
  width:36px;
  border-radius: 999px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  background-color: #8B8B89;
  color: white;
  font-weight: largest;

  &:hover {
    background-color: black;
    color:white;
  }
`)

export const ProfileName = styled('span')(``)

export const TooltipWrapper = styled(({ className, ...props }) => (
  <Tooltip
    {...props}
    PopperProps={{
      modifiers: [
        {
          name: 'offset',
          options: {
            offset: [0, 8],
          },
        },
      ],
    }}
    classes={{ popper: className }}
  />
))(
  () => `
  & .${tooltipClasses.tooltip} {
    background-color: #EFEFEF;
    color: #000;
    font-size: 12px;
    font-weight: 400;
    padding: 2px 8px;
    border-radius: 2px;
    box-shadow: 0 0 12 px 0 rgba(0, 0, 0, 0.51);
    transform: translateX(-5px) !important;
  }`
)
